/**
 * 再买一单按钮
 */
import { Icon } from '@cps'
import React, { FC, useEffect } from 'react'
import { orderMobx, storeMobx, productCenter, cartMobx, productMobx, restaurantCenter, replaceCartItemPk } from 'restaurant'
import { modalLayer, loadingLayer, showMsg, useHistoryNew } from '@utils'
import { SoldWarnModal } from '@pages/checkout/modal'
import './index.scss'
import { trace } from '@dt/fe-utils'

interface IProps {
  info: IOrder;
}

// 轮训就餐方式定时器
let waitEatTypeTimer = null
/** 用于监听 */
let eventBus
let timer = null

const OrderBuyAgainBtn: FC<IProps> = (props: IProps) => {
  const { info } = props
  const { ordersId } = info
  const history = useHistoryNew()

  // 取消订阅
  const clearEvent = () => {
    eventBus && restaurantCenter.off(eventBus)
    timer && clearTimeout(timer)
    waitEatTypeTimer && clearInterval(waitEatTypeTimer)
  }

  /** 获取订单详情 */
  const setOrder = async () => {
    try {
      if (info.ordersId === orderMobx.order.ordersId) {
        return orderMobx.order
      } else {
        const order = await orderMobx.init(ordersId)
        return order
      }
    } catch (error) {
      return null
    }
  }

  /** 获取当前订单关联门店，并选中该门店 */
  const setStore = (order?: IOrder) => {
    // 品牌码下才可能没有门店
    if (!order) return false
    if (Config.codeType === 'brand') {
      const orderStore = storeMobx.storeIdToViewStore[order.storeId]
      // 门店营业中
      if (orderStore?.status === 'inSale') {
        storeMobx.initInfo(orderStore)
        return orderStore
      } else { // 当前门店未在营业中，就找第一家
        const firstStore = storeMobx.viewStoreList[0] || null
        if (firstStore) {
          storeMobx.initInfo(firstStore)
        } else {
          showMsg('cart.errorClose')
        }
        return firstStore
      }
    } else {
      return storeMobx.info
    }
  }

  const setProduct = () => {
    waitEatTypeTimer && clearInterval(waitEatTypeTimer)
    if (productMobx.products.length) {
      console.log(3, '商品数据_old', productMobx.products)
      setCart(productMobx.products)
    } else {
      waitEatTypeTimer = setInterval(async () => {
        if (cartMobx.info.eatType) {
          clearInterval(waitEatTypeTimer)
          // 没有餐品数据需要重新请求
          await productCenter.initProduct(cartMobx.info.eatType, storeMobx.info.storeId)
          console.log(3, '商品数据_initProduct', productMobx.products)
          setCart(productMobx.products)
        }
      }, 100)
    }
  }

  /** 设置购物车数据从订单还原，并前往购物车 */
  const setCart = (hasProduct) => {
    if (hasProduct) {
      clearEvent()
      loadingLayer.hide()
      setTimeout(() => {
        cartMobx.restoreOrderToCart((cartItems: ICartItem[]) => {
          let _cartItems: ICartItem[] = cartItems.map((item) => {
            return {
              ...replaceCartItemPk(item),
              isTogo: cartMobx.info.eatType !== 'dinein' ? 1 : 0
            }
          })
          cartMobx.setCartItems(_cartItems, true)
          // 有售罄餐品，需要弹窗提示
          if (cartMobx.viewDisabledCartItems.length) {
            // 全部售罄
            const isAllSold = cartMobx.viewDisabledCartItems.length === cartItems.length
            modalLayer(SoldWarnModal, {
              title: (
                <div className='sold-title-wrap'>
                  <div className='sold-title'>{i18n.t('menu.soldBuyAgain')}</div>
                  <span className='sold-desc'>{i18n.t('menu.changeBuyAgain')}</span>
                </div>
              ),
              errData: cartMobx.viewDisabledCartItems
            }).then(() => {
              cartMobx.clearDisabledItems()
              if (isAllSold) {
                history.replace('/menu')
              } else {
                history.push('/checkout')
              }
            }).catch(() => {
              cartMobx.clearDisabledItems()
              history.replace('/menu')
            })
          } else {
            history.push('/checkout')
          }
        })
      }, 100)
    }
  }

  /** 点击再来一单 */
  const handle = async (event) => {
    event.stopPropagation()
    // 取消订阅
    eventBus && restaurantCenter.off(eventBus)
    timer && clearTimeout(timer)

    /** 开始 */
    loadingLayer.show()
    timer = setTimeout(() => {
      clearEvent()
      loadingLayer.hide()
    }, 5000)
    const order: IOrder = await setOrder()

    console.log(1, '订单数据', order)
    const store: IViewStore | false = setStore(order)
    console.log(2, '门店数据', store)
    setProduct()
    logUp(order)
  }

  /** 上报再来一单 */
  const logUp = (order) => {
    try {
      trace.traceLog({
        name: '再来一单 => ',
        message: { error: order, ordersId }
      })
    } catch (error) {
    }
  }

  useEffect(() => {
    return () => {
      // 取消订阅
      clearEvent()
    }
  }, [])

  return (
    <div className='order-buy-again-container' onClick={handle}>
      <Icon name='cart' />
      <span>{i18n.t('order.buyAgainOrder')}</span>
    </div>
  )
}

export default OrderBuyAgainBtn
